// extracted by mini-css-extract-plugin
export default {"root":"MenuLabel_root__0OLFX","clickedWithMouse":"MenuLabel_clickedWithMouse__koRT+","isOpen":"MenuLabel_isOpen__88UCL"};